import { render, staticRenderFns } from "./fangan.vue?vue&type=template&id=16def70a&scoped=true&"
import script from "./fangan.vue?vue&type=script&lang=ts&"
export * from "./fangan.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16def70a",
  null
  
)

export default component.exports